import { Component, Input, EventEmitter, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { take } from 'rxjs/operators';
import { ModalService } from '@app/@core/modal/modal.service';
import { SpinnerService } from '../spinner/spinner.service';
import { CustomDialogComponent } from '../modal/customDialog/customDialog.component';
import { UserService } from '@app/services/user.service';
import { Survey } from '@app/interface/survey';
import { ClonesurveyService } from '../../services/clonesurvey.service';
@Component({
  selector: 'app-survey-table',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss'],
})
export class SurveyTableComponent {
  @Input() isLoading = false;
  @Input() message: string;
  @Input() dataTable: Survey[];
  @Input() dataColumn: string;
  first = 0;
  rows = 5;
  values = '';
  dialogRef: any;

  @Output() surveyDetailEvent = new EventEmitter<Survey>();

  constructor(
    private modalService: ModalService,
    private messageService: MessageService,
    private spinnerService: SpinnerService,
    public userService: UserService,
    private cloneSurveyService: ClonesurveyService
  ) {}

  getIndex(arr: any, survey: any) {
    let index = arr.map((item: any) => item.id).indexOf(survey['id']);
    return index;
  }

  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  isLastPage(): boolean {
    return this.dataTable ? this.first === this.dataTable.length - this.rows : true;
  }

  isFirstPage(): boolean {
    return this.dataTable ? this.first === 0 : true;
  }

  deleteSurvey(survey: any): void {
    this.modalService
      .confirm('Are you sure that you want to remove ' + survey['name'])
      .pipe(take(1))
      .subscribe((confirmed: any) => {
        if (confirmed) {
          this.spinnerService.show();
          this.removeSurvey(survey);
        }
      });
  }

  async cloneQuestionForm(survey: any) {
    this.cloneSurveyService.cloneSurvey(survey);
  }

  openEditForm(formData: any): void {
    this.modalService
      .custom(CustomDialogComponent, {
        title: 'Edit Survey',
        modalType: 'add-edit-survey',
        formType: 'Edit',
        formData: formData,
      })
      .pipe(take(1))
      .subscribe((result: any) => {
        if (result) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Survey is added succesfully.' });
        }
      });
  }

  removeSurvey(survey: any): void {
    this.userService.deleteSurvey(survey.uuid).then(() => {
      this.spinnerService.hide();
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: survey['name'] + ' is deleted successfully',
      });
    });
  }

  openDetailSurvey(survey: any): void {
    this.surveyDetailEvent.emit(survey);
  }
}
